export default __webpack_public_path__ + "static/media/purpleBigDiary.47c69298.png";